<template>
  <v-container
    v-touch="{
      down: () => swipeRefresh()
    }"
  >
    <v-row>
      <v-col>
        <div
          v-infinite-scroll="loadNewsletters"
          infinite-scroll-disabled="infiniteScrollBusy"
          infinite-scroll-distance="1"
          infinite-scroll-immediate-check="true"
        >
          <v-list
            v-for="(month, name) in groupNewsletters"
            :key="name"
          >
            <v-subheader class="px-0 success--text pb-5">
              {{ name }}
            </v-subheader>
            <v-list-item
              class="mx-n4 py-2"
              v-for="newsletter in month"
              :key="newsletter.id"
              @click="openNewsletter(newsletter)"
            >
              <v-list-item-avatar>
                <div
                  class="school-logo"
                  :style="`border-color: ${getSchoolColour(newsletter.domain)}`"
                >
                  <v-img
                    :src="getLogo(newsletter.domain)"
                    height="26"
                    width="26"
                    contain
                    class="flex-shrink-0 flex-grow-0"
                  />
                </div>
              </v-list-item-avatar>
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  :class="
                    $store.getters['readNewsletters'].find(
                      a => a === newsletter.id
                    )
                      ? 'read mb-1'
                      : 'mb-1'
                  "
                >
                  {{ newsletter.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div class="font-weight-medium mb-1">
                    {{ getName(newsletter.domain) }}
                  </div>
                  <div>
                    {{ getSubtitle(newsletter) }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn
                  icon
                  @click.stop="openNewsletter(newsletter)"
                  @click="openShareSheet(newsletter)"
                >
                  <v-icon>mdi-share-variant-outline</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import groupBy from "lodash/groupBy";
import {
  FA_SCREEN_VIEW,
  FA_SCREEN_CLASS,
  FA_SCREEN_NAME
} from "@/settings/constants";
import { getCookie } from "@/mixins/cookies";

const Newsletters = {
  computed: {
    ...mapGetters(["newsletters", "schoolsLogo", "appFilters"]),
    groupNewsletters: function() {
      if (this.newsletters.items && this.newsletters.items.length > 0) {
        return groupBy(this.newsletters.items, newsletter =>
          new Date(newsletter.date).toLocaleDateString(getCookie("locale"), {
            month: "long",
            year: "numeric"
          })
        );
      } else {
        return null;
      }
    },
    totalItems: function() {
      return this.newsletters.total;
    }
  },
  components: {},
  name: "Newsletters",
  title: "Newsletters",
  created: function() {
    this.$store.dispatch("getNewsletters", {
      page: this.page,
      itemsPerPage: this.itemsPerPage
    });
    this.analytics(FA_SCREEN_VIEW, {
      [FA_SCREEN_CLASS]: "newsletters",
      [FA_SCREEN_NAME]: "newsletters_feed"
    });
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      infiniteScrollBusy: false
    };
  },
  methods: {
    loadNewsletters() {
      this.infiniteScrollBusy = true;
      if (this.page * this.itemsPerPage > this.totalItems) {
        this.infiniteScrollBusy = false;
        return;
      }
      this.page = this.page + 1;
      this.$store.dispatch("getNewsletters", {
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });
      this.infiniteScrollBusy = false;
    },
    applyFilters() {
      this.page = 1;
      this.$store.dispatch("getNewsletters", {
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });
    },
    getLogo(schoolId) {
      return this.schoolsLogo.filter(
        schoolInfo => schoolInfo.schoolId == schoolId
      )[0]
        ? this.schoolsLogo.filter(
            schoolInfo => schoolInfo.schoolId == schoolId
          )[0].logo
        : null;
    },
    getName(schoolId) {
      return this.schoolsLogo.filter(
        schoolInfo => schoolInfo.schoolId == schoolId
      )[0]
        ? this.schoolsLogo.filter(
            schoolInfo => schoolInfo.schoolId == schoolId
          )[0].name
        : null;
    },
    openNewsletter(newsletter) {
      const { id, type, link, filePath, title } = newsletter;
      this.$store.dispatch("setNewsletterRead", id);
      this.analytics(FA_SCREEN_VIEW, {
        [FA_SCREEN_CLASS]: "newsletters",
        [FA_SCREEN_NAME]: title.replaceAll(" ", "_")
      });

      if (type === "link") {
        //eslint-disable-next-line
        NativeJS.externalLink(link);
      } else if (type === "file") {
        //eslint-disable-next-line
        NativeJS.openPDF(filePath);
      }
    },
    calculateSize(bytes, decimals = 2) {
      if (bytes == 0 || bytes == null) return "";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    swipeRefresh() {
      if (window.pageYOffset === 0) {
        this.$store.dispatch("getNewsletters", {
          page: this.page,
          itemsPerPage: this.itemsPerPage
        });
      }
    },
    openShareSheet(newsletter) {
      if (newsletter.type === "link") {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `sharing ${newsletter.title} at url ${newsletter.link}`
        );
        //eslint-disable-next-line
        NativeJS.openShareSheet(newsletter.link, newsletter.title);
      } else if (newsletter.type === "file") {
        //eslint-disable-next-line
        NativeJS.debugLog(
          `sharing ${newsletter.title} at url ${newsletter.filePath}`
        );
        //eslint-disable-next-line
        NativeJS.openShareSheet(newsletter.filePath, newsletter.title);
      }
    },
    getSchoolColour(schoolId) {
      if (schoolId != "global") {
        return this.schoolsLogo.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )?.colour;
      }
      return "#264189";
    },
    getSubtitle(newsletter) {
      const isLink = newsletter.type === "link";
      let isExternal = false;
      if (isLink) {
        let link = "";
        if (newsletter.link.startsWith("http")) {
          link = newsletter.link;
        } else {
          link = "http://" + newsletter.link;
        }
        const linkUrl = new URL(link);
        isExternal = !linkUrl.hostname.endsWith("nsw.gov.au");
      }

      const fileType = newsletter.fileType ?? "";
      const fileSize = this.calculateSize(newsletter.fileSize);
      const linkText = isLink && isExternal ? this.$t("newsletters.link") : "";
      let subText = `${fileType} ${fileSize} ${linkText}`.trim();
      if (subText.length > 0) {
        subText = "- " + subText;
      }
      return `${new Date(newsletter.date).toLocaleDateString(
        getCookie("locale"),
        {
          month: "long",
          year: "numeric",
          day: "numeric"
        }
      )} ${subText}`.trim();
    }
  },
  watch: {
    appFilters: {
      deep: true,
      handler() {
        this.applyFilters();
      }
    }
  }
};
export default Newsletters;
</script>
<style lang="scss" scoped>
.v-subheader {
  font-size: 1.25rem;
}
.v-list-item {
  border-bottom: 1px solid #f7f7f7;
}
.v-list-item__title {
  font-size: 1.125rem;
  font-weight: 500;
}
.theme--light.v-list-item .v-list-item__subtitle {
  color: #121212;
}
.school-logo {
  height: 40px;
  width: 40px;
  padding: 5px;
  border: 2px solid;
  border-radius: 100px;
}
.read {
  color: rgba(0, 0, 0, 0.6);
}
</style>
